// extracted by mini-css-extract-plugin
export var icon = "_7s-1";
export var subtext = "_7s-0";